import { gql } from "@apollo/client";

export const MUTATION_DELETE_USER_OFFER = gql`
  mutation DeleteUserOffer($offerId: ID!) {
    deleteUserOffer(offerId: $offerId)
  }
`;
